(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  const initBeforeAfterCarousels = () => {
    document.querySelectorAll('.before-after-carousel-section').forEach(section => {
      const track = section.querySelector('.ba-carousel__track');
      const prevBtn = section.querySelector('.ba-carousel__arrow--prev');
      const nextBtn = section.querySelector('.ba-carousel__arrow--next');
      const dotsContainer = section.querySelector('.ba-carousel__dots');

      if (!track || !prevBtn || !nextBtn) return;

      const items = track.querySelectorAll('.ba-carousel__item');

      // Build dots for mobile
      if (dotsContainer && items.length > 1) {
        dotsContainer.innerHTML = '';
        items.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.classList.add('ba-carousel__dot');
          dot.setAttribute('aria-label', `Ir para item ${i + 1}`);
          dot.addEventListener('click', () => {
            track.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
          });
          dotsContainer.appendChild(dot);
        });
      }

      let itemOffsets = [];
      let maxScroll = 0;
      let scrollAmount = 0;

      const cacheDimensions = () => {
        itemOffsets = Array.from(items).map(item => item.offsetLeft);
        maxScroll = track.scrollWidth - track.clientWidth;

        const item = track.querySelector('.ba-carousel__item');
        if (item) {
          const itemWidth = item.offsetWidth;
          const style = window.getComputedStyle(track);
          const gap = parseFloat(style.gap || style.columnGap) || 16;
          scrollAmount = itemWidth + gap;
        } else {
          scrollAmount = track.clientWidth * 0.75;
        }
      };

      cacheDimensions();

      const updateDots = () => {
        if (!dotsContainer || items.length <= 1) return;
        const dots = dotsContainer.querySelectorAll('.ba-carousel__dot');
        if (!dots.length) return;

        const scrollLeft = track.scrollLeft;
        let activeIndex = 0;
        let minDistance = Infinity;
        itemOffsets.forEach((offsetLeft, i) => {
          const distance = Math.abs(offsetLeft - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = i;
          }
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('ba-carousel__dot--active', i === activeIndex);
        });
      };

      const updateArrows = () => {
        const scrollLeft = track.scrollLeft;

        // Disable prev button if at the very start
        if (scrollLeft <= 5) {
          prevBtn.setAttribute('disabled', 'true');
        } else {
          prevBtn.removeAttribute('disabled');
        }

        // Disable next button if at the very end
        if (scrollLeft >= maxScroll - 5) {
          nextBtn.setAttribute('disabled', 'true');
        } else {
          nextBtn.removeAttribute('disabled');
        }
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      track.addEventListener('scroll', () => { updateArrows(); updateDots(); }, { passive: true });
      window.addEventListener('resize', () => {
        cacheDimensions();
        updateArrows();
        updateDots();
      }, { passive: true });

      updateArrows();
      updateDots();
      setTimeout(() => {
        cacheDimensions();
        updateArrows();
        updateDots();
      }, 200);
      setTimeout(() => {
        cacheDimensions();
        updateArrows();
        updateDots();
      }, 800);
    });
  };

  if (document.readyState !== 'loading') {
    initBeforeAfterCarousels();
  } else {
    document.addEventListener('DOMContentLoaded', initBeforeAfterCarousels);
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('shopify-section') && event.target.querySelector('.before-after-carousel-section')) {
      initBeforeAfterCarousels();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secao-c"] && !Shopify.designMode) return;
  try {
    
  function highlightPercentages() {
    document.querySelectorAll('.secao-c__description').forEach(function (desc) {
      if (!desc.classList.contains('js-highlighted')) {
        var rawHtml = desc.innerHTML;
        var newHtml = rawHtml.replace(/(\b\d+%\b)/g, '<strong class="secao-c__percentage">$1</strong>');
        if (newHtml !== rawHtml) {
          desc.innerHTML = newHtml;
        }
        desc.classList.add('js-highlighted');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightPercentages);
  } else {
    highlightPercentages();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.secao-c__description').forEach(function (desc) {
      desc.classList.remove('js-highlighted');
    });
    highlightPercentages();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wave-banner__carousel-wrapper').forEach(function (wrapper) {
      var carousel = wrapper.querySelector('.wave-banner__carousel');
      var btnPrev = wrapper.querySelector('.wave-banner__arrow--prev');
      var btnNext = wrapper.querySelector('.wave-banner__arrow--next');

      if (!carousel || !btnPrev || !btnNext) return;

      function getItemWidth() {
        var item = carousel.querySelector('.wave-banner__carousel-item');
        if (!item) return carousel.offsetWidth;
        var style = window.getComputedStyle(carousel);
        var gap = parseFloat(style.columnGap || style.gap) || 16;
        return item.offsetWidth + gap;
      }

      btnPrev.addEventListener('click', function () {
        carousel.scrollBy({ left: -getItemWidth(), behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function () {
        carousel.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
